var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"verification-notice"},[_c('h1',[_vm._v(_vm._s(_vm.$t(`Email Already Verified`)))]),_c('p',{staticClass:"email-desc"},[_vm._v(_vm._s(_vm.$t('Your email has already been verified'))+". "+_vm._s(_vm.$t(`No further action is required`))+".")])])
}
var staticRenderFns = []

export { render, staticRenderFns }